export default __webpack_public_path__ + "static/media/about_icon2.b747fe79.svg";